import React, { Component } from 'react';
import styled from 'styled-components/macro';
import { Rnd } from 'react-rnd';
import './Container.css';

const StyledContainer = styled.div`
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: background-color 100ms ease-in-out;
  background-color: ${({theme, active}) => active ? theme.bg00 : theme.bg00};
`

const handlers={
  top:true,
  right:true,
  bottom:true,
  left:true,
  topRight:true,
  bottomRight:true,
  bottomLeft:true,
  topLeft:true
};

const handleClasses = {
  bottom: "Container-handle-horizontal",
  bottomLeft: "Container-handle-corner",
  bottomRight: "Container-handle-corner",
  left: "Container-handle-vertical",
  right: "Container-handle-vertical",
  top: "Container-handle-horizontal",
  topLeft: "Container-handle-corner",
  topRight: "Container-handle-corner"
}

class Container extends Component{

  constructor(props){
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onResizeStart = this.onResizeStart.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onResizeStop = this.onResizeStop.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
    this.onDrag = this.onDrag.bind(this);
    this.onDragStrop = this.onDragStrop.bind(this);
    this.rnd = React.createRef();
  }

  onClick(e){
    e.stopPropagation();
  }

  // disable and enable Artboard Click
  onResizeStart(){
    this.props.artboard.disableClick();
  }

  // update Size and Position
  onResize(e, direction, ref, delta, position){
    let {action, index} = this.props;
    action.updatePosition(index, position.x, position.y)
    action.updateSize(index, ref.offsetWidth, ref.offsetHeight)
  }

  onResizeStop(){
    setTimeout(() => this.props.artboard.enableClick(), 300);
  }

  // set active Object
  onDragStart(){
    this.props.action.setActive(this.props.index);
  }

  onDrag(e,{x,y}){
    let {action, index} = this.props;
    action.updatePosition(index, x, y);
  }

  onDragStrop(){
    // let {action, index} = this.props;
    // let {x, y} = this.rnd.current.draggable.state;
    // action.updatePosition(index, x, y)
  }

  render(){
    let { size, position, active } = this.props;
    let zIndex = active ? 1000 : 200;

    return(
        <Rnd
          id={this.props.containerID}
          style={{zIndex}}
          ref={this.rnd}
          // default={{...defaultPosition, ...defaultSize}}
          size={size}
          position={position}
          onDragStart={this.onDragStart}
          onDrag={this.onDrag}
          onDragStop={this.onDragStrop}
          onResizeStop={this.onResizeStop}
          onResize={this.onResize}
          onResizeStart={this.onResizeStart}
          resizeGrid={[20, 20]}
          dragGrid={[20, 20]}
          minWidth={60}
          minHeight={60}
          enableResizing={active ? handlers : false}
          resizeHandleClasses={handleClasses}
        >
          <StyledContainer active={active} onClick={this.onClick}>
            { this.props.children(size) }
          </StyledContainer>
        </Rnd>
    )
  }
}

export default Container;